export const TOO_MANY_ATTEMPTS_ERROR_CODE = 'TOO_MANY_ATTEMPTS';

interface RefusalLike {
  code?: unknown;
  retryAfterSeconds?: unknown;
}

// The localized "too many attempts" text with the wait in whole minutes, or null for any other error.
export function resolveTooManyAttemptsMessage(error: unknown, template: string): string | null {
  const refusal = error as RefusalLike | null;
  if (!refusal || refusal.code !== TOO_MANY_ATTEMPTS_ERROR_CODE) {
    return null;
  }

  const retryAfterSeconds = refusal.retryAfterSeconds;
  const minutes =
    typeof retryAfterSeconds === 'number' && retryAfterSeconds > 0
      ? Math.ceil(retryAfterSeconds / 60)
      : 1;

  return template.replace('{minutes}', String(minutes));
}
